import { render, staticRenderFns } from "./EODLogs.vue?vue&type=template&id=59f2a54e&"
import script from "./EODLogs.vue?vue&type=script&lang=js&"
export * from "./EODLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports